import { Alert, Container } from "react-bootstrap"
import { UAParser } from "ua-parser-js"
import { BrowserName } from "ua-parser-js/enums"

const { browser } = UAParser(navigator.userAgent)

const BrowserWarning = () => {
	if (!browser) {
		return null
	}

	switch (browser.name) {
		case BrowserName.CHROME:
		case BrowserName.EDGE: {
			return null
		}
		default: {
			// Unsupported
			return (
				<Container>
					<Alert variant="warning" className="my-3">
						<h3>
							Radmin does not support {browser.name}. Please try
							again in a different browser such as chrome.
						</h3>
					</Alert>
				</Container>
			)
		}
	}
}

export default BrowserWarning
